export default {"src":"/_next/static/media/loadingIcon.c29d87bc.svg","height":54,"width":54,"blurWidth":0,"blurHeight":0};